<template>
  <div>
    <menu-item
      :item="menu"
      :key="menu.id"
      v-for="menu in menus"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import MenuItem from '@/components/menu/MenuItem';
import MenuItemMixin from '@/mixins/MenuItemMixin';

export default {
  name: 'AdminMenu',

  mixins: [
    MenuItemMixin,
  ],

  components: {
    MenuItem,
  },

  props: {
    view: {
      type: String,
      required: false,
    },
  },

  computed: {
    ...mapGetters('admin', {
        pendingSpacesCount: 'GET_ALL_PENDING_SPACES_COUNT',
        pendingHabitatPass: 'GET_ALL_PENDING_HABITAT_PASS_COUNT',
        pendingIntegral: 'GET_ALL_PENDING_INTEGRAL_COUNT',
        pendingContentProductions: 'GET_ALL_PENDING_CONTENT_PRODUCTION',
      }),
    ...mapGetters('validateUser', {
      allDoctorsValidationsCount: 'GET_ALL_DOCTORS_VALIDATIONS_COUNT',
    }),

    menus() {
      const hasValidations = this.allDoctorsValidationsCount > 0;
      const hasPendingAds = this.pendingSpacesCount > 0;
      const hasPendingHabitatPass = this.pendingHabitatPass > 0;
      const hasPendingIntegral = this.pendingIntegral > 0;

      return [
        {
          active: this.isActive('admin-dashboard'),
          color: 'blue',
          icon: 'mdi-desktop-mac-dashboard',
          title: this.$t('menu.adminDashBoard'),
          to: 'admin-dashboard',
        },
        {
          active: this.isActive('admin-subscription-user'),
          color: 'green',
          icon: 'mdi-file-document-outline',
          title: this.$t('menu.userSubscriptionDashBoard'),
          to: 'admin-subscription-user',
        },
        {
          active: this.isActive('admin-plans'),
          color: 'purple',
          icon: 'mdi-card-text',
          title: this.$t('menu.adminPlans'),
          to: 'admin-plans',
        },
        {
          active: this.isActive('admin-modules'),
          color: 'orange',
          icon: 'mdi-package',
          title: this.$t('menu.adminModules'),
          to: 'admin-modules',
        },
        {
          active: this.isActive('admin-content-productions'),
          alert: this.pendingContentProductions > 0,
          color: 'blue',
          icon: 'mdi-file-document-edit-outline',
          title: this.$t('menu.adminContentProduction'),
          to: 'admin-content-productions',
        },
        {
          active: this.isActive('admin-subscriptions'),
          color: 'green',
          icon: 'mdi-file-document-outline',
          title: this.$t('menu.subscriptions'),
          to: 'admin-subscriptions',
        },
        {
          active: this.isActive('admin-spaces'),
          color: 'purple',
          icon: 'mdi-domain',
          title: this.$t('menu.spaces'),
          to: 'admin-spaces',
        },
        {
          active: this.isActive('admin-coupons'),
          color: 'orange',
          icon: 'mdi-ticket-percent',
          title: this.$t('menu.coupons'),
          to: 'admin-coupons',
        },
        {
          active: this.isActive('admin-habitat-pass'),
          alert: hasPendingHabitatPass,
          color: 'blue',
          icon: 'mdi-fire',
          title: this.$t('menu.habitatPass'),
          to: 'admin-habitat-pass',
        },
        {
          active: this.isActive('admin-monthly-integral'),
          alert: hasPendingIntegral,
          color: 'green',
          icon: 'mdi-post',
          title: this.$t('menu.integralRequests'),
          to: 'admin-monthly-integral',
        },
        {
          active: this.isActive('admin-transactions'),
          color: 'purple',
          icon: 'mdi-cash',
          title: this.$t('menu.transactions'),
          to: 'admin-transactions',
        },
        {
          active: this.isActive('admin-saas', 'admin-saas-details', 'admin-saas-events', 'admin-saas-subscription'),
          color: 'orange',
          icon: 'mdi-account-multiple',
          title: this.$t('menu.saas'),
          to: 'admin-saas',
        },
        {
          active: this.isActive('admin-users', 'admin-user-details', 'admin-user-profile', 'admin-user-events', 'admin-user-owner-calendar', 'admin-user-transactions', 'admin-user-products', 'admin-user-subscription', 'admin-user-hour-package'),
          color: 'blue',
          icon: 'mdi-account-multiple',
          title: this.$t('menu.users'),
          to: 'admin-users',
        },
        {
          active: this.isActive('admin-marketplace'),
          color: 'blue',
          icon: 'mdi-shopping',
          title: this.$t('menu.marketplace'),
          to: 'admin-marketplace',
        },
        {
          active: this.isActive('admin-validate-doctors'),
          alert: hasValidations,
          color: 'green',
          icon: 'mdi-account-multiple',
          title: this.$t('menu.validateUsers'),
          to: 'admin-validate-doctors',
        },
        {
          active: this.isActive('admin-validate-companies'),
          color: 'purple',
          icon: 'mdi-domain',
          title: this.$t('menu.validateCompanies'),
          to: 'admin-validate-companies',
        },
        {
          active: this.isActive('admin-validate-spaces'),
          alert: hasPendingAds,
          color: 'orange',
          icon: 'mdi-newspaper-variant',
          title: this.$t('menu.validateAdvertisements'),
          to: 'admin-validate-spaces',
        },
        {
          active: this.isActive('admin-finance', 'admin-finance-overview', 'admin-finance-receivers', 'admin-finance-receiver-details', 'admin-finance-receiver-banks', 'admin-finance-receiver-transactions', 'admin-finance-receiver-history', 'admin-finance-receiver-transfer', 'admin-finance-receiver-documents'),
          color: 'blue',
          icon: 'mdi-finance',
          title: this.$t('menu.finance'),
          to: 'admin-finance',
        },
        {
          active: this.isActive('admin-reports'),
          color: 'green',
          icon: 'mdi-chart-pie',
          title: this.$t('menu.reports'),
          to: 'admin-reports',
        },
        {
          color: 'purple',
          icon: 'mdi-rss',
          href: 'https://blog.habitatconsultorios.com.br/',
          target: '_blank',
          title: this.$t('menu.blog'),
        },
      ].filter(Boolean);
    },
  },
}
</script>
